import axios from "axios";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
export const api = axios.create({ baseURL: API, withCredentials: true });

let pending = 0;
let slowTimer;
const emitNet = (detail) => window.dispatchEvent(new CustomEvent("ks-net", { detail }));
const settle = () => { pending = Math.max(0, pending - 1); if (!pending) { clearTimeout(slowTimer); emitNet("fast"); } };
api.interceptors.request.use((c) => { if (++pending === 1) slowTimer = setTimeout(() => emitNet("slow"), 8000); return c; });
api.interceptors.response.use((r) => { settle(); return r; }, (e) => {
  settle();
  if (!e.response && !axios.isCancel(e)) emitNet("down");
  return Promise.reject(e);
});

export function errMsg(e) {
  const d = e?.response?.data?.detail;
  if (!e?.response) return "No internet connection. Please check your network and try again.";
  if (!d) return "Something went wrong. Please try again.";
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((x) => `${(x.loc || []).slice(-1)[0] || ""}: ${x.msg}`).join(" ");
  if (d.message) return d.message;
  return String(d);
}

export const fileUrl = (p) => `${API}/files/${p}`;

export const todayIST = () => new Date().toLocaleDateString("en-CA", { timeZone: "Asia/Kolkata" });
export const nowHourIST = () =>
  parseInt(new Date().toLocaleString("en-GB", { timeZone: "Asia/Kolkata", hour: "2-digit", hour12: false }), 10);

export const isPastSlot = (date, slot) => {
  const today = todayIST();
  if (date < today) return true;
  return date === today && parseInt(slot.slice(0, 2), 10) <= nowHourIST();
};

export const fmtDate = (d, lang = "en") =>
  new Date(d + (d.length === 10 ? "T00:00:00" : "")).toLocaleDateString(lang === "hi" ? "hi-IN" : "en-IN", {
    weekday: "short", day: "numeric", month: "short",
  });

export const fmtDateTime = (iso) =>
  new Date(iso).toLocaleString("en-IN", { day: "numeric", month: "short", hour: "numeric", minute: "2-digit" });

export const timeAgo = (iso, t = (x) => x) => {
  const m = Math.max(0, Math.round((Date.now() - new Date(iso).getTime()) / 60000));
  if (m < 60) return m <= 1 ? t("just now") : `${m} ${t("min ago")}`;
  const h = Math.round(m / 60);
  if (h < 24) return `${h} ${t(h === 1 ? "hour ago" : "hours ago")}`;
  const d = Math.round(h / 24);
  return d < 7 ? `${d} ${t(d === 1 ? "day ago" : "days ago")}` : fmtDateTime(iso);
};

export const payText = (p) => {
  if (!p || p.method === "Cash") return "Cash";
  if (p.method === "UPI") return `UPI · ${p.upi_masked || ""}`;
  return `Bank · ${p.holder || ""} · ****${p.account_last4 || ""}`;
};

export const emptyForm = (user) => ({
  scrap_types: [], other_text: "", est_weight: "",
  lat: user?.lat ?? null, lng: user?.lng ?? null, address: user?.address || "", landmark: user?.landmark || "",
  date: todayIST(), slot: "", payment_method: "Cash", upi_id: "", bank_holder: "", bank_account: "", bank_ifsc: "",
  note: "", photo_path: "", repeat: "",
});

export const toPayload = (f) => ({ ...f, est_weight: f.est_weight === "" || f.est_weight === null ? null : Number(f.est_weight) });
